(()=>{'use strict';
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine=matchMedia('(hover: hover) and (pointer: fine)').matches;
const $=(s,r=document)=>r.querySelector(s),$$=(s,r=document)=>[...r.querySelectorAll(s)];
const raf=fn=>requestAnimationFrame(fn);

/* ---------- selectors that get 3D behaviour automatically ---------- */
const REVEAL='.section-heading,.vb-gender-tile,.vb-promo,.product-card,.category-card,.edit-tile,.vb-shoe-style,.vb-brand-tile,.vb-condition-card,.vb-review-card,.vb-trust-item,.vb-size-box,.vb-budget-card,.vb-help,.vb-faq-item,.vb-story-banner,.vb-newsletter-inner,.vb-tabs';
const TILT='.product-card,.category-card,.edit-tile,.vb-condition-card,.vb-review-card,.vb-gender-tile,.vb-promo,.vb-budget-card,.vb-brand-tile,.vb-size-box';

/* ---------- scroll progress / header / back-to-top ---------- */
const bar=$('.vb-progress'),top=$('.vb-top'),header=$('.site-header');
let ticking=false;
const onScroll=()=>{ticking=false;const y=scrollY,h=document.documentElement.scrollHeight-innerHeight;
  if(bar)bar.style.transform=`scaleX(${h>0?Math.min(1,y/h):0})`;
  if(header)header.classList.toggle('is-stuck',y>24);
  if(top)top.classList.toggle('show',y>700);
  const tk=$('.vb-ticker-track');if(tk&&!reduce){const v=Math.max(-6,Math.min(6,(y-(onScroll.last||y))*.25));onScroll.last=y;$('.vb-ticker').style.transform=`skewX(${-v}deg)`;clearTimeout(onScroll.t);onScroll.t=setTimeout(()=>{const t=$('.vb-ticker');if(t)t.style.transform=''},180)}
  heroParallax(y)};
addEventListener('scroll',()=>{if(!ticking){ticking=true;raf(onScroll)}},{passive:true});
top?.addEventListener('click',()=>scrollTo({top:0,behavior:reduce?'auto':'smooth'}));

/* ---------- scroll reveal ---------- */
let io;
const revealInit=(scope=document)=>{
  if(!('IntersectionObserver' in window)||reduce)return;
  io=io||new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:.12,rootMargin:'0px 0px -6% 0px'});
  $$(REVEAL,scope).forEach(el=>{
    if(el.dataset.vbReveal!==undefined)return;
    el.dataset.vbReveal='';
    const sib=el.parentElement?[...el.parentElement.children].filter(c=>c.matches(REVEAL)):[];
    el.style.setProperty('--vb-i',Math.min(sib.indexOf(el),8)<0?0:Math.min(sib.indexOf(el),8));
    io.observe(el);
  });
};

/* ---------- 3D tilt with glare ---------- */
const tiltInit=(scope=document)=>{
  if(!fine||reduce)return;
  $$(TILT,scope).forEach(el=>{
    if(el.dataset.vbTilt!==undefined)return;
    el.dataset.vbTilt='';
    const max=el.classList.contains('vb-size-box')?3:9;
    let r;
    el.addEventListener('pointerenter',()=>{r=el.getBoundingClientRect();el.classList.add('is-tilting')});
    el.addEventListener('pointermove',e=>{if(!r)r=el.getBoundingClientRect();
      const px=(e.clientX-r.left)/r.width,py=(e.clientY-r.top)/r.height;
      el.style.transform=`perspective(900px) rotateX(${((.5-py)*max).toFixed(2)}deg) rotateY(${((px-.5)*max*1.2).toFixed(2)}deg) translateZ(8px)`;
      el.style.setProperty('--gx',px*100+'%');el.style.setProperty('--gy',py*100+'%')},{passive:true});
    el.addEventListener('pointerleave',()=>{el.classList.remove('is-tilting');el.style.transform='';r=null});
  });
};

/* ---------- magnetic buttons ---------- */
const magnetInit=(scope=document)=>{
  if(!fine||reduce)return;
  $$('.btn:not(.wide),.vb-pill',scope).forEach(b=>{
    if(b.dataset.vbMagnet!==undefined)return;b.dataset.vbMagnet='';
    b.addEventListener('pointermove',e=>{const r=b.getBoundingClientRect();b.style.transform=`translate(${((e.clientX-r.left-r.width/2)*.18).toFixed(1)}px,${((e.clientY-r.top-r.height/2)*.3).toFixed(1)}px)`},{passive:true});
    b.addEventListener('pointerleave',()=>{b.style.transform=''});
  });
};

/* ---------- hero 3D stage + parallax ---------- */
let hero,stageInner,mx=0,my=0;
const SHAPES=[
 ['cube',72,'8%','18%',-40,'20s'],['cube',44,'46%','12%',60,'16s'],['cube',96,'84%','62%',-80,'26s'],
 ['ring',150,'62%','8%',20,'22s'],['ring',90,'6%','68%',-30,'18s'],
 ['orb',58,'72%','30%',90,'7s'],['orb',34,'30%','74%',50,'9s'],['orb',22,'92%','14%',-20,'6s']
];
const heroInit=()=>{
  hero=$('.hero');if(!hero||reduce||$('.vb-stage',hero))return;
  const stage=document.createElement('div');stage.className='vb-stage';stage.setAttribute('aria-hidden','true');
  stageInner=document.createElement('div');stageInner.className='vb-stage-inner';
  SHAPES.forEach(([t,s,l,tp,z,d],i)=>{const n=document.createElement('div');n.className='vb-shape '+t;
    n.style.cssText=`--s:${s}px;--t:${d};left:${l};top:${tp};transform:translateZ(${z}px);animation-delay:${-i*1.7}s`;
    if(t==='cube')n.innerHTML='<i></i><i></i><i></i><i></i><i></i><i></i>';
    n.dataset.depth=z;stageInner.append(n)});
  stage.append(stageInner);hero.prepend(stage);
  const cue=document.createElement('span');cue.className='vb-hero-scrollcue';cue.setAttribute('aria-hidden','true');hero.append(cue);
  if(fine)hero.addEventListener('pointermove',e=>{const r=hero.getBoundingClientRect();mx=(e.clientX-r.left)/r.width-.5;my=(e.clientY-r.top)/r.height-.5;
    raf(()=>{stageInner.style.transform=`rotateY(${(mx*14).toFixed(2)}deg) rotateX(${(-my*10).toFixed(2)}deg)`;
      const art=$('.hero-art',hero),copy=$('.hero-copy',hero);
      if(art)art.style.transform=`rotateY(${(mx*12).toFixed(2)}deg) rotateX(${(-my*9).toFixed(2)}deg)`;
      if(copy)copy.style.transform=`translate3d(${(mx*-10).toFixed(1)}px,${(my*-8).toFixed(1)}px,0)`})},{passive:true});
  if(fine)hero.addEventListener('pointerleave',()=>{stageInner.style.transform='';const a=$('.hero-art',hero),c=$('.hero-copy',hero);if(a)a.style.transform='';if(c)c.style.transform=''});
};
const heroParallax=y=>{if(!hero||reduce)return;const r=hero.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;
  $$('.vb-shape',hero).forEach(s=>{const z=Number(s.dataset.depth)||0;s.style.marginTop=(y*z*-.0016).toFixed(1)+'px'})};

/* ---------- announcement rotator ---------- */
const rotator=()=>{
  const box=$('.vb-announce');if(!box)return;const items=$$('span',box);if(items.length<2){return}
  box.classList.add('vb-ready');let i=0;items[0].classList.add('is-on');
  if(reduce)return;
  setInterval(()=>{if(document.hidden)return;const cur=items[i];i=(i+1)%items.length;const nx=items[i];
    cur.classList.remove('is-on');cur.classList.add('is-out');nx.classList.remove('is-out');nx.classList.add('is-on');
    setTimeout(()=>cur.classList.remove('is-out'),750)},3800);
};

/* ---------- tabs (arrivals) ---------- */
const tabsInit=(scope=document)=>{
  $$('[data-vb-tabs]',scope).forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='1';
    const tabs=$$('[role=tab]',root),panels=$$('[role=tabpanel]',root),pill=$('.vb-tab-pill',root);
    const move=t=>{if(!pill)return;pill.style.width=t.offsetWidth+'px';pill.style.transform=`translateX(${t.offsetLeft}px)`};
    const pick=t=>{tabs.forEach((x,i)=>{const on=x===t;x.setAttribute('aria-selected',on);x.tabIndex=on?0:-1;panels[i]?.classList.toggle('is-on',on);if(panels[i])panels[i].hidden=!on});move(t)};
    tabs.forEach((t,i)=>{t.addEventListener('click',()=>pick(t));t.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){const n=tabs[(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length];n.focus();pick(n)}})});
    const first=tabs.find(t=>t.getAttribute('aria-selected')==='true')||tabs[0];if(first)raf(()=>pick(first));
    addEventListener('resize',()=>{const s=tabs.find(t=>t.getAttribute('aria-selected')==='true');if(s)move(s)},{passive:true});
    document.fonts?.ready.then(()=>{const s=tabs.find(t=>t.getAttribute('aria-selected')==='true');if(s)move(s)});
  });
};

/* ---------- counters ---------- */
const countInit=(scope=document)=>{
  const els=$$('[data-vb-count]',scope);if(!els.length)return;
  const run=el=>{const to=parseFloat(el.dataset.vbCount),dec=(el.dataset.vbCount.split('.')[1]||'').length,suf=el.dataset.suffix||'';
    if(reduce||isNaN(to)){el.textContent=to.toLocaleString('en-US',{minimumFractionDigits:dec})+suf;return}
    const t0=performance.now(),d=1400;const step=t=>{const p=Math.min(1,(t-t0)/d),e=1-Math.pow(1-p,3);
      el.textContent=(to*e).toLocaleString('en-US',{minimumFractionDigits:dec,maximumFractionDigits:dec})+suf;if(p<1)raf(step)};raf(step)};
  if(!('IntersectionObserver' in window)){els.forEach(run);return}
  const o=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){run(e.target);o.unobserve(e.target)}}),{threshold:.6});els.forEach(e=>o.observe(e));
};

/* ---------- mobile bottom nav active state ---------- */
const bottomNav=()=>{const p=location.pathname;$$('.vb-bottom a').forEach(a=>{const h=a.getAttribute('href');const on=h==='/'?p==='/':p.startsWith(h.split('?')[0]);a.classList.toggle('is-active',on)})};

/* ---------- fly to cart ---------- */
document.addEventListener('vb:added',e=>{
  const card=e.detail&&e.detail.form&&e.detail.form.closest('.product-card');
  const badge=$('[data-cart-count]');
  if(badge){badge.classList.remove('bump');void badge.offsetWidth;badge.classList.add('bump')}
  if(reduce||!card||!badge)return;
  const img=$('img',card);if(!img)return;
  const a=img.getBoundingClientRect(),b=badge.getBoundingClientRect();
  const f=img.cloneNode();f.className='vb-fly';f.removeAttribute('srcset');f.removeAttribute('sizes');
  Object.assign(f.style,{left:a.left+'px',top:a.top+'px',width:a.width+'px',height:a.height+'px',opacity:'1'});
  document.body.append(f);
  raf(()=>raf(()=>{f.style.width='34px';f.style.height='34px';f.style.opacity='.2';
    f.style.transform=`translate(${b.left-a.left-a.width/2+10}px,${b.top-a.top-a.height/2+10}px) rotate(540deg) scale(.6)`}));
  setTimeout(()=>f.remove(),1000);
});

/* ---------- boot ---------- */
const boot=(scope=document)=>{revealInit(scope);tiltInit(scope);magnetInit(scope);tabsInit(scope);countInit(scope)};
const start=()=>{rotator();heroInit();bottomNav();boot();onScroll()};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
document.addEventListener('shopify:section:load',e=>{heroInit();boot(e.target)});
})();
